import { z } from 'zod';

/**
 * Wire do `GET /bus/searches/recent`: o BFF valida a resposta
 * com este schema antes do `res.json`, e o web-chat a lê com ele na borda.
 * Irmão do `RentalRecentSearchSchema`.
 *
 * Uma busca recente é o critério que `POST /bus/search` recebeu, pronto para
 * ser reenviado: a rodoviária de origem e de destino (`code` é o slug do
 * bus-api, `name` o que a pessoa escolheu) e os dias (`2026-08-25`).
 * `returnDate` ausente ⇔ só ida.
 *
 * Mais recente primeiro, na ordem em que o back-end devolve. Pode vir vazio —
 * recente é conveniência, e o BFF degrada para `[]` em qualquer falha.
 */
const BusRecentStopSchema = z.object({
  code: z.string().min(1),
  name: z.string().min(1),
});

export const BusRecentSearchSchema = z.object({
  from: BusRecentStopSchema,
  to: BusRecentStopSchema,
  outwardDate: z.iso.date(),
  returnDate: z.iso.date().optional(),
});
export type BusRecentSearch = z.infer<typeof BusRecentSearchSchema>;

export const BusRecentSearchesResponseSchema = z.object({
  searches: z.array(BusRecentSearchSchema),
});
